import { render, staticRenderFns } from "./entryCenterUrl.vue?vue&type=template&id=28ba7f62&scoped=true&"
import script from "./entryCenterUrl.vue?vue&type=script&lang=js&"
export * from "./entryCenterUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba7f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ba7f62')) {
      api.createRecord('28ba7f62', component.options)
    } else {
      api.reload('28ba7f62', component.options)
    }
    module.hot.accept("./entryCenterUrl.vue?vue&type=template&id=28ba7f62&scoped=true&", function () {
      api.rerender('28ba7f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/entryCenterUrl.vue"
export default component.exports